import React from 'react';
import PropTypes from 'prop-types';

import SimilarSeriesTitlesContainer from 'react/containers/SimilarSeriesTitlesContainer';
import DetailViewHeader from "react/views/detailView/DetailViewHeader";
import DetailViewTitle from "react/views/detailView/DetailViewTitle";
import ScrollableText from 'react/views/generic/ScrollableText';
import {ItemHeight} from 'react/views/similarSeries/SimilarSeriesTitles';
import SimilarSeriesEventTypes from "data/types/SimilarSeriesEventTypes";
import DetailsFooter from "react/card/DetailsFooter";
import ContentTitle from "react/views/generic/ContentTitle";

import 'react/views/cardDetails.less';
import 'react/views/series/seriesDetails.less';
import { ReasoningLabel } from 'react/views/generic/ReasoningLabel';

const SeriesDetails = (props) => (
    <div className="series-details">
        <div className="series-details-header">
            <DetailViewHeader>
                <DetailViewTitle title={props.title} uniqueId={props.uniqueId}>
                    <ContentTitle numLines={props.otsEnabled ? 1 : 2}>{props.title}</ContentTitle>
                </DetailViewTitle>
            </DetailViewHeader>
        </div>
        <div className="series-details-body">
            <div className="series-details-titles" style={{maxHeight: ItemHeight}}>
                <SimilarSeriesTitlesContainer {...props} marginTop={0} marginBottom={'0.5em'}/>
            </div>
            <div className="series-details-reasoning">
				<ReasoningLabel featureName={"series"} />
                <ScrollableText line={4}>
                    {props.reasonText}
                </ScrollableText>
            </div>
        </div>
        <DetailsFooter linkToNovelist={props.linkToNovelist}
            pLinkFeatureType={SimilarSeriesEventTypes.SIMILARSERIES_NOVELIST_CLICKED}
            pLinkDestId={props.uniqueId}
            activeTitleUi={props.activeTitleUi}/>
    </div>
);

SeriesDetails.propTypes = {
    uniqueId: PropTypes.string.isRequired,
    activeTitleUi: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    authorName: PropTypes.string.isRequired,
    reasonText: PropTypes.string,
    isLoading: PropTypes.bool,
    seriesResultData: PropTypes.object,
    linkToNovelist: PropTypes.string,
    otsEnabled: PropTypes.bool
}

SeriesDetails.defaultProps = {
    otsEnabled: false
}

export default SeriesDetails;



// WEBPACK FOOTER //
// ./src/react/views/series/SeriesDetails.jsx